import request from '../../api/request';

export const getCertificateFormStructure = (
  certificateTypeCode: string,
  studyPlanEnrollmentId?: number,
) => {
  return request(
    `students-portal/student-certificates/certificate-type/${certificateTypeCode}/form`,
    {
      params: {
        studyPlanEnrollmentId,
      },
    },
  );
};
